import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { prefersReducedMotion } from './usePrefersReducedMotion';

/**
 * Animates a number counting up from 0 to `value` on mount/update — used
 * for dashboard portfolio figures (total capital, ROI, wallet balance) and
 * marketing stat bands. Reduced-motion users get the final formatted value
 * immediately rather than watching it count up.
 */
export function useCountUp(value, { duration = 1, formatter = (n) => Math.round(n).toLocaleString() } = {}) {
  const elRef = useRef(null);

  useEffect(() => {
    const el = elRef.current;
    if (!el) return undefined;

    if (prefersReducedMotion()) {
      el.textContent = formatter(value || 0);
      return undefined;
    }

    const obj = { val: 0 };
    const tween = gsap.to(obj, {
      val: value || 0,
      duration,
      ease: 'power2.out',
      onUpdate: () => {
        el.textContent = formatter(obj.val);
      },
    });

    return () => tween.kill();
  }, [value, duration, formatter]);

  return elRef;
}
